var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.texto && _vm.texto.length > _vm.tamanho && _vm.tamanhoJanela.x >= 720)?_c('v-tooltip',{attrs:{"bottom":""}},[_c('template',{slot:"activator"},[_c('span',[_vm._v(_vm._s(_vm._f("azClipText")(_vm.texto,_vm.tamanho)))])]),_c('span',[_vm._v(_vm._s(_vm.texto))])],2):_c('span',[_vm._v(_vm._s(_vm.texto))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }